// generated with @7nohe/openapi-react-query-codegen@2.0.0

import { type Options } from "@hey-api/client-fetch";
import { UseQueryResult } from "@tanstack/react-query";
import {
  createTranslationJob,
  getDocumentAiAnalyzeIdResults,
  getDocumentAiAnalyzeIdStatus,
  getDocumentAiResults,
  getDocumentAiStatus,
  getTranslationJob,
  polishMessage,
  reprocessDocumentAi,
  translateMessage,
} from "../requests/services.gen";
import {
  GetDocumentAiAnalyzeIdResultsData,
  GetDocumentAiAnalyzeIdStatusData,
  GetDocumentAiResultsData,
  GetDocumentAiStatusData,
  GetTranslationJobData,
} from "../requests/types.gen";
export type GetDocumentAiStatusDefaultResponse = Awaited<
  ReturnType<typeof getDocumentAiStatus>
>["data"];
export type GetDocumentAiStatusQueryResult<
  TData = GetDocumentAiStatusDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetDocumentAiStatusKey = "GetDocumentAiStatus";
export const UseGetDocumentAiStatusKeyFn = (
  clientOptions: Options<GetDocumentAiStatusData, true>,
  queryKey?: Array<unknown>
) => [useGetDocumentAiStatusKey, ...(queryKey ?? [clientOptions])];
export type GetDocumentAiResultsDefaultResponse = Awaited<
  ReturnType<typeof getDocumentAiResults>
>["data"];
export type GetDocumentAiResultsQueryResult<
  TData = GetDocumentAiResultsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetDocumentAiResultsKey = "GetDocumentAiResults";
export const UseGetDocumentAiResultsKeyFn = (
  clientOptions: Options<GetDocumentAiResultsData, true>,
  queryKey?: Array<unknown>
) => [useGetDocumentAiResultsKey, ...(queryKey ?? [clientOptions])];
export type GetDocumentAiAnalyzeIdStatusDefaultResponse = Awaited<
  ReturnType<typeof getDocumentAiAnalyzeIdStatus>
>["data"];
export type GetDocumentAiAnalyzeIdStatusQueryResult<
  TData = GetDocumentAiAnalyzeIdStatusDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetDocumentAiAnalyzeIdStatusKey =
  "GetDocumentAiAnalyzeIdStatus";
export const UseGetDocumentAiAnalyzeIdStatusKeyFn = (
  clientOptions: Options<GetDocumentAiAnalyzeIdStatusData, true>,
  queryKey?: Array<unknown>
) => [useGetDocumentAiAnalyzeIdStatusKey, ...(queryKey ?? [clientOptions])];
export type GetDocumentAiAnalyzeIdResultsDefaultResponse = Awaited<
  ReturnType<typeof getDocumentAiAnalyzeIdResults>
>["data"];
export type GetDocumentAiAnalyzeIdResultsQueryResult<
  TData = GetDocumentAiAnalyzeIdResultsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetDocumentAiAnalyzeIdResultsKey =
  "GetDocumentAiAnalyzeIdResults";
export const UseGetDocumentAiAnalyzeIdResultsKeyFn = (
  clientOptions: Options<GetDocumentAiAnalyzeIdResultsData, true>,
  queryKey?: Array<unknown>
) => [useGetDocumentAiAnalyzeIdResultsKey, ...(queryKey ?? [clientOptions])];
export type GetTranslationJobDefaultResponse = Awaited<
  ReturnType<typeof getTranslationJob>
>["data"];
export type GetTranslationJobQueryResult<
  TData = GetTranslationJobDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetTranslationJobKey = "GetTranslationJob";
export const UseGetTranslationJobKeyFn = (
  clientOptions: Options<GetTranslationJobData, true>,
  queryKey?: Array<unknown>
) => [useGetTranslationJobKey, ...(queryKey ?? [clientOptions])];
export type ReprocessDocumentAiMutationResult = Awaited<
  ReturnType<typeof reprocessDocumentAi>
>;
export const useReprocessDocumentAiKey = "ReprocessDocumentAi";
export const UseReprocessDocumentAiKeyFn = (mutationKey?: Array<unknown>) => [
  useReprocessDocumentAiKey,
  ...(mutationKey ?? []),
];
export type TranslateMessageMutationResult = Awaited<
  ReturnType<typeof translateMessage>
>;
export const useTranslateMessageKey = "TranslateMessage";
export const UseTranslateMessageKeyFn = (mutationKey?: Array<unknown>) => [
  useTranslateMessageKey,
  ...(mutationKey ?? []),
];
export type PolishMessageMutationResult = Awaited<
  ReturnType<typeof polishMessage>
>;
export const usePolishMessageKey = "PolishMessage";
export const UsePolishMessageKeyFn = (mutationKey?: Array<unknown>) => [
  usePolishMessageKey,
  ...(mutationKey ?? []),
];
export type CreateTranslationJobMutationResult = Awaited<
  ReturnType<typeof createTranslationJob>
>;
export const useCreateTranslationJobKey = "CreateTranslationJob";
export const UseCreateTranslationJobKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateTranslationJobKey,
  ...(mutationKey ?? []),
];
